const CalculationTableRecord = ({
    flowMeterName,
    base,
    statePattern,
    stateCurrent,
    datetimeFrom,
    datetimeTo
}) => {
    const circleGreen = () => {
        return (
            <td>
                <span className="circle-div-wrapper">
                    <div className="circle-green"/>
                </span>
            </td>
        )
    }
    const circleYellow = () => {
        return (
            <td>
                <span className="circle-div-wrapper">
                    <div className="circle-yellow"/>
                </span>
            </td>
        )
    }
    const circleRed = () => {
        return (
            <td>
                <span className="circle-div-wrapper">
                    <div className="circle-red"/>
                </span>
            </td>
        )
    }
    const handleCircle = (state) => {
        if (state === "CALCULATED") {
            return circleGreen();
        } else if (state === "IN_PROGRESS") {
            return circleYellow()
        } else if (state === "NOT_CALCULATED") {
            return circleRed()
        }
    }
    return (
        <tr>
            <td>{flowMeterName}</td>
            <td style={{textAlign: "center"}}>{base}</td>
            {handleCircle(statePattern)}
            <td> {new Date(datetimeFrom).toLocaleString("pl-PL", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit"
                })}
            </td>
            <td> {new Date(datetimeTo).toLocaleString("pl-PL", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit"
                })}
            </td>
            {handleCircle(stateCurrent)}
        </tr>
    )
}

export default CalculationTableRecord;